export default __webpack_public_path__ + "static/media/twicegroup.6c2bba9f.jpg";